import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./assets/styles.css";

import router from "./routes/router";
import store from "./store/store";
// layouts
import SubscriberLayout from "./layout/_pages/subscriber.vue";
import ShopLayout from "./layout/_pages/shop.vue";
import OrderLayout from "./layout/_pages/orders.vue";
import AdminLayout from "./layout/_pages/admin.vue";
import GeneralLayout from "./layout/_pages/general.vue";
// import PosLayout from './layout/pos.vue';
// import AdminLayout from './layout/admin.vue';
import AuthLayout from "./layout/auth.vue";

// socket.io imports
// import socketio from 'socket.io-client';
// import VueSocketIO from 'vue-socket.io';
// end

// import snackbar
import PdfPreview from "@/components/global/pdfmodal.vue";
import ExcelPreview from "@/components/global/excelmodal.vue";
import Snackbar from "@/components/global/snackbar.vue";
import DatePicker from "@/components/global/datepicker.vue";
import DashPicker from "@/components/subscriber/dashboard/datepicker.vue";

import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import JsonExcel from "vue-json-excel";

// initialize here
// const SocketInstance = socketio.connect('http://localhost:3000');

// Vue.use(new VueSocketIO({
//     debug: true,
//     connection: SocketInstance
// }));



import DateFilter from "./filters/date";
import CurrencyFilter from "./filters/currency";
import WholeNumber from "./filters/whole-number";
Vue.filter("date", DateFilter);
Vue.filter("currency", CurrencyFilter);
Vue.filter("whole-number", WholeNumber);

Vue.use(Chartkick.use(Chart));
Vue.component("downloadExcel", JsonExcel);
Vue.component("Snackbar", Snackbar);
Vue.component("PdfPreview", PdfPreview);
Vue.component("ExcelPreview", ExcelPreview);
Vue.component("DatePicker", DatePicker);
Vue.component("DashPicker", DashPicker);
Vue.component("AuthLayout", AuthLayout);
Vue.component("OrderLayout", OrderLayout);
Vue.component("ShopLayout", ShopLayout);
Vue.component("AdminLayout", AdminLayout);
Vue.component("GeneralLayout", GeneralLayout);
Vue.component("SubscriberLayout", SubscriberLayout);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
